import { getApiBaseUrl, getApiKey } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'

const API_BASE = (getApiBaseUrl()).replace(/\/+$/, '');
const API_KEY = getApiKey();
const withApiKey = (path) => `${API_BASE}${path}${API_KEY ? `?apiKey=${API_KEY}` : ''}`;


const getAllPromoCreate = async ()=>{
    const response = await axios.get(withApiKey('/marketing/getPromoCreateList/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllPromoCreate = data;

    console.log('Сервер вернул данные по отметкам - ',response.data);


    return AllPromoCreate;
};


const setActivePromoCreate = async (id,val)=>{
    const response = await axios.post(withApiKey('/marketing/setActivePromoCreate/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllPromoCreate = data;

    // console.log('Сервер вернул данные по обновлению статуса User  - ',response);


    return AllPromoCreate;
};



const setDeletedPromoCreate = async (id,val)=>{
    const response = await axios.post(withApiKey('/marketing/setDeletedPromoCreate/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllPromoCreate = data;

    // console.log('Сервер вернул данные по обновлению статуса User  - ',response);


    return AllPromoCreate;
};




const setUpdatePromoCreate = async (dataPromoCreateUpdate)=>{
    const response = await axios.post(withApiKey('/marketing/setUpdatePromoCreate/'),{
        "dataUpdate":dataPromoCreateUpdate
    });

    if (!response?.data || Object.keys(response.data).length === 0) {
        return { error: true, result: false, message: 'Пустой ответ API setUpdatePromoCreate', data: null };
    }

    const {error, errorInfo, result, message, data } = response.data;
    const AllPromoCreate = response.data;

    // console.log('Сервер вернул данные по обновлению статуса User  - ',dataUserUpdate,response);


    return AllPromoCreate;
};


const setSaveNewPromoCreate = async (dataUpdate)=>{
    const response = await axios.post(withApiKey('/marketing/setNewPromoCreate/'),{
        dataUpdate
    });
    const {error, errorInfo, result, message, data } = response.data;
    const AllPromoCreate =  response.data;

    // console.log('Сервер вернул данные по обновлению статуса User  - ',response, dataUserUpdate);


    return AllPromoCreate;
};

const setUpdatePromoCreateCategory = async (dataPromocodeForCategoryUpdate)=>{
    const response = await axios.post(withApiKey('/marketing/setUpdatePromocodeForCategory/'),{
        dataPromocodeForCategoryUpdate
    });
    return response.data;
};

const setDeletedPromoCreateCategory = async (id,val)=>{
    const response = await axios.post(withApiKey('/marketing/setPromocodeForCategoryDeleted/'),{
        id,
        val
    });
    return response.data;
};

const setSaveNewPromoCreateCategory = async (dataPromocodeForCategoryInsert)=>{
    const response = await axios.post(withApiKey('/marketing/setSaveNewPromocodeForCategory/'),{
        dataPromocodeForCategoryInsert
    });
    return response.data;
};

Mock.onGet('/api/marketing/getPromoCreateList').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllPromoCreate = await getAllPromoCreate();
    console.log('С сервера пришло - ', AllPromoCreate);

    // if (!AllUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllPromoCreate) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllPromoCreate,
    ]


})


Mock.onPost('/api/marketing/setActivePromoCreate').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllPromoCreate = await setActivePromoCreate(id,val);

    // if (!AllPromoCreate) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllPromoCreate) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllPromoCreate,
    ]


})

Mock.onPost('/api/marketing/setDeletedPromoCreate').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllPromoCreate = await setDeletedPromoCreate(id,val);

    // if (!AllUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllPromoCreate) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllPromoCreate,
    ]


})


Mock.onPost('/api/marketing/setUpdatePromoCreate').reply(async (config) => {
    const parsed = JSON.parse(config.data);
    const dataUserUpdate = parsed?.dataUserUpdate || parsed?.dataUpdate || {};

    const PromoCreate = await setUpdatePromoCreate(dataUserUpdate);
    const {error, errorInfo, result, message, data } = PromoCreate;

    if (!PromoCreate) {
        return [400, {promoCreateList:[],result:PromoCreate.result}]
    }


    return [
        200,
        {promoCreateList:data,result:result,error:error,errorInfo:errorInfo},
    ]


})


Mock.onPost('/api/marketing/setNewPromoCreate').reply(async (config) => {
    const parsed = JSON.parse(config.data);
    const dataPromoCreateUpdate = parsed?.dataPromoCreateUpdate || parsed?.dataUserUpdate || parsed?.dataUpdate || {};
    const PromoCreate = await setSaveNewPromoCreate(dataPromoCreateUpdate);
    const {error, errorInfo, result, message, data } = PromoCreate;

    if (!PromoCreate) {
        return [400, {promoCreateList:[],result:result,error:error,errorInfo:errorInfo,message:message}]
    }


    return [
        200,
        {promoCreateList:data,result:result,error:error,errorInfo:errorInfo,message:message},
    ]
})

Mock.onPost('/api/marketing/setUpdatePromocodeForCategory').reply(async (config) => {
    const parsed = JSON.parse(config.data);
    const payload = parsed?.dataPromocodeForCategoryUpdate || {};
    const response = await setUpdatePromoCreateCategory(payload);
    const {error, errorInfo, result, message, data } = response;
    return [
        200,
        {promoCreateList:data,result:result,error:error,errorInfo:errorInfo,message:message},
    ];
});

Mock.onPost('/api/marketing/setPromocodeForCategoryDeleted').reply(async (config) => {
    const parsed = JSON.parse(config.data);
    const id = parsed?.id;
    const val = parsed?.val;
    const response = await setDeletedPromoCreateCategory(id, val);
    const {error, errorInfo, result, message, data } = response;
    return [
        200,
        {promoCreateList:data,result:result,error:error,errorInfo:errorInfo,message:message},
    ];
});

Mock.onPost('/api/marketing/setSaveNewPromocodeForCategory').reply(async (config) => {
    const parsed = JSON.parse(config.data);
    const payload = parsed?.dataPromocodeForCategoryInsert || {};
    const response = await setSaveNewPromoCreateCategory(payload);
    const {error, errorInfo, result, message, data } = response;
    return [
        200,
        {promoCreateList:data,result:result,error:error,errorInfo:errorInfo,message:message},
    ];
});
